import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faArrowTrendUp, faBoxArchive, faFileExport, faFolderPlus, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { Rights } from 'src/app/models/server/enums/rights';
import { View } from 'src/app/models/server/view';
import { DialogService } from 'src/app/services/actions/dialog.service';
import { FolderActionsService } from 'src/app/services/actions/folder-actions.service';
import { EventsManagerService } from 'src/app/services/events/events-manager.service';
import { ConnectedUsersStateService } from 'src/app/services/state/connected-users-state.service';
import { ViewsStateService } from 'src/app/services/state/views-state.service';

@Component({
    selector: 'app-folders-list-command-bar',
    templateUrl: './folders-list-command-bar.component.html',
    styleUrls: ['./folders-list-command-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatTooltipModule, FaIconComponent]
})
export class FoldersListCommandBarComponent {
    /**
     * Référence des icones utilisées dans le template
     */
    public addFolderIcon = faFolderPlus;
    public refreshIcon = faRotateRight;
    public archivedFoldersAccessIcon = faBoxArchive;
    public exportIcon = faFileExport;
    public liveFoldersAccessIcon = faArrowTrendUp;

    /**
     * Valeur indiquant si l'utilisateur a le droit de créer un dossier.
     */
    public folderCreationRight: boolean = false;

    /**
     * Valeur indiquant si l'utilisateur a le droit de consulter les dossiers archivés.
     */
    public archiveConsultattionRight: boolean = false;

    /**
     * Valeur indiquant si l'utilisateur a le droit d'exporter les dossiers.
     */
    public foldersExportRight: boolean = false;

    /**
     * Vue affichée dans la liste des dossiers.
     */
    @Input()
    public view: View = null;

    /**
     * Constructeur.
     * @param folderActionsService : Service de gestion des actions sur les dossiers.
     * @param dialogService : Service de gestion des boites de dialogue.
     * @param connectedUserStateService : Service de gestion de l'état de l'utilisateur connecté.
     * @param eventsManagerService : Service de gestion des événements.
     * @param viewsStateService : Service de gestion de la vue courante.
     */
    constructor(
        private folderActionsService: FolderActionsService,
        private dialogService: DialogService,
        private connectedUserStateService: ConnectedUsersStateService,
        private eventsManagerService: EventsManagerService,
        public viewsStateService: ViewsStateService
    ) {
        this.folderCreationRight = this.connectedUserStateService.hasRight(Rights.FolderCreate);
        this.archiveConsultattionRight = this.connectedUserStateService.hasRight(Rights.ArchiveRead);
        this.foldersExportRight = this.connectedUserStateService.hasRight(Rights.ExportFolders);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton de rafraichissement de la liste des dossiers.
     */
    public onRefresh() {
        this.eventsManagerService.emitListRefreshEvent();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton de création d'un dossier.
     */
    public onCreateFolder() {
        this.dialogService.openAddFolder(this.view.viewType).subscribe((data) => {
            if (!!data) {
                this.folderActionsService.addFolder(data.folder, true);
            }
        });
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton d'accès aux dossiers archivés ou le bouton d'accès au dossiers courants.
     */
    public onSwitchBetweenArchivedAndLiveFoldersList() {
        this.viewsStateService.selectLinkedView(this.view);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton d'export des dossiers.
     */
    public onExport() {
        this.eventsManagerService.emitFolderListExportEvent();
    }
}
